import gql from 'graphql-tag';

const DEVICE_TROUBLESHOOTING_FILTER_LIST_VIEW = gql`
  query Query(
    $filters: [String!]
    $skip: Int!
    $limit: Int!
    $currentView: String!
    $searchParam: String!
    $searchText: String!
  ) {
    deviceTroubleShootingFiltersListView(
      filters: $filters
      skip: $skip
      limit: $limit
      currentView: $currentView
      searchParam: $searchParam
      searchText: $searchText
    ) {
      totalCount
      result {
        latitude
        longitude
        elevation
        deviceType
        revoked
        deviceSerialNo
        broker
        hardwareVersion
        isBillable
        version
        status
        simNumber
        networkProvider
        stage
        firmwareVersion
        customerName
        customerType
        category
        plotName
        cropName
        cropIdentifier
        varietyIdentifier
        isInfluentialCustomer
        soilType
        soilIdentifier
        sensorData {
          battery {
            datetime
            value
          }
          lastSyncTime
          errorData
        }
        pauseData {
          pausedOn
          reason
        }
      }
    }
  }
`;

export default DEVICE_TROUBLESHOOTING_FILTER_LIST_VIEW;
